import { Record } from "immutable";

import "seneca-common/features/class/state";

import { AccessorRoleType } from "seneca-common/features/class/state";

export type ClassTeacherType = {
  userId: string;
  name: string;
  role: AccessorRoleType;
};

export default class ClassTeacher extends Record({
  userId: null,
  name: null,
  role: null
}) {}
